import React from 'react';
import classnames from 'classnames';
import { Props as IconProps, IconSize } from '../IconWrap';
import s from './CircleWrap.scss';

export interface Props extends IconProps {
  circleClassName?: string;
  children: React.ReactNode;
}

const CircleWrap: React.FC<Props> = ({
  size = IconSize.MEDIUM,
  circleClassName,
  children,
  ...props
}) => {
  return (
    <span className={classnames(s['disc'], s[size], circleClassName)}>
      {children}
    </span>
  );
};
CircleWrap.displayName = 'CircleWrap';

export default CircleWrap;
